import Axios from 'axios';
import { API_URL, COMMENT_APP_ID } from '@src/constants';
import { jsonp } from '@ifeng-fe/ui_base';
import { Grounds } from '@ifeng-fe/client_grounds';
import {
    getClientParams, // 客户端标参
    showInput, // 端内评论
} from '@src/utils/app';
// 弹窗
import { message as toast } from '@src/components/ModalBox';
// axios实例
export const axios = Axios.create();

// axios实例的基础路径
axios.defaults.baseURL = API_URL;

// 客户端标参
const clientParams = getClientParams();

axios.interceptors.request.use(
    config => {
        return { ...config, params: { ...config.params, ...clientParams } };
    },
    err => {
        return Promise.reject(err);
    },
);

axios.interceptors.response.use(
    response => {
        const { status, data } = response;

        return { ...data, httpStatus: status };
    },
    err => {
        return Promise.resolve(err);
    },
);

const request = async ({ url, params, name }) => {
    if (window.grounds) {
        return await Grounds.nativeRequest({
            // eslint-disable-next-line no-undef
            url: apiUrl + url,
            getParams: JSON.stringify(params),
            type: 'get',
        });
    } else {
        // eslint-disable-next-line no-undef
        return await jsonp(apiUrl + url, {
            data: params,
            jsonpCallback: name + Date.now(),
            cache: false,
        });
    }
};

// ------------------------------------- //
// 视频详情
export const getVideoDetail = async videoId => {
    // eslint-disable-next-line no-undef
    switch (NODE_ENV) {
        case 'development': // 开发
            // Mock数据
            return await axios.get(
                'https://api.ifengcloud.ifeng.com/mock/1060/KVProxy.getDocument/6763691451625775294',
            );

        // return await request({
        //     url: 'http://test.nine.ifeng.com/phoenixtv/recommed?from=screen_recom',
        //     params: {},
        //     name: 'getCommunityInfoNav',
        // });
        case 'staging': // 测试
            return await request({
                url: `${API_URL}/community/api_community/getCommunityInfoNav?communityId=${videoId}`,
                params: {},
                name: 'getCommunityInfoNav',
            });
        default:
            return await request({
                url: `${API_URL}/community/api_community/getCommunityInfoNav?communityId=${videoId}`,
                params: {},
                name: 'getCommunityInfoNav',
            });
    }
};

// 更多推荐
export const getRecommend = async ({ page = 1, pageSize = 10, docId }) => {
    // Mock数据
    // return await axios.get('https://api.ifengcloud.ifeng.com/mock/524/phoenixtv/recommed');
    return await request({
        url: '/recommend',
        params: {
            from: 'screen_recom',
            page,
            pageSize,
            docId,
        },
        name: 'getCommunityInfoNav',
    });
};

// 点赞接口
// export const sendLike = (doc_url, vote_user, cmtid) => {
//     return request.get('/community/api_comment/voteUp', {
//         params: {
//             doc_url,
//             vote_user,
//             cmtid,
//         },
//     });
// };

// 获取ifeng图片尺寸
export const getIfengImageSize = url => {
    const pattern = /https?:\/\/.+_w(\d+)_h(\d+)\..+/g;
    const [, width, height] = pattern.exec(url);

    return [parseInt(width), parseInt(height)];
};
/*
replyName:
quote_id评论id
doc_url
doc_name
callback
*/
// 发布评论
export const replyComment = ({ replyName, doc_url, doc_name, quote_id, callback }) => {
    showInput({
        replyName,
        callback: async inputString => {
            try {
                // 解析输入框返回的数据
                const inputData = JSON.parse(inputString.replace(/\n/g, '\\n').replace(/\r/g, '\\r'));
                // 处理输入框返回的数据
                const text = inputData.text.trim();
                const { image } = inputData;
                let pics = '';

                if (image) {
                    const [width, height] = getIfengImageSize(image);

                    pics = JSON.stringify([[image, width, height]]);
                }

                // 请求评论接口
                // const res = await postComment({ doc_url, doc_name, text, ...(pics.length ? { pics } : {}), quote_id });
                // const { code, msg } = res;

                // if (code === 1) {
                //     toast({
                //         content: (
                //             // eslint-disable-next-line react/jsx-filename-extension
                //             <div className={styles.replySuccess}>
                //                 <div className={styles.replySuccessIcon} />
                //                 <div>发布成功，正在审核中</div>
                //             </div>
                //         ),
                //     });
                // } else {
                //     toast({ content: msg });
                // }
            } catch (e) {
                console.error(e);
            }
        },
    });
};

/*
orderby: 排序
comment_id:评论id
p:
pagesize:请求数量
// display_hotlist: 显示热门0不显示1显示
doc_url:评论id
*/
// 获取评论列表(H5评论列表客户端不需要)
// export const getList = ({ orderby, comment_id, p, pagesize = 20, display_hotlist = 0, doc_url }) => {
//     return request.get('/community/api_comment/getlistv2', {
//         params: {
//             orderby,
//             comment_id,
//             p,
//             pagesize,
//             display_hotlist,
//             doc_url,
//         },
//     });
// };
